export enum ECardOrderReason {
    Member_Error_Charges_Fee = 1,
    FitnessPassport_Error_No_Charges_Fee = 2
}